import * as React from 'react';
import { useSelector } from 'react-redux';

import { FloatingLabel } from 'shared/components/FloatingLabel';
import { selectOfferType, selectRosReestrSelector } from 'shared/selectors';

import { getRosReestrTooltipText } from './utils/getRosReestrTooltipText';
import { useApplicationContext } from '../ApplicationContext';

export function RosReestrLabelContainer() {
  const { config } = useApplicationContext();
  const offerType = useSelector(selectOfferType);
  const rosReestrTooltipText = getRosReestrTooltipText(offerType, config);
  const isRosReestr = useSelector(selectRosReestrSelector);

  if (!isRosReestr) {
    return null;
  }

  return (
    <FloatingLabel
      data-testid="RosReestrLabel"
      labelText="Проверено в Росреестре"
      tooltipTitle={rosReestrTooltipText.title}
      tooltipText={rosReestrTooltipText.description}
      color="decorative-theme-dark"
      backgroundColor="overlay-control-dark"
      hasListStyle
    />
  );
}
